var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative",attrs:{"id":"home"}},[_vm._m(0),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"background-blur",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"blur bg-gradient-1"}),_c('div',{staticClass:"blur bg-gradient-2"})])
}]

export { render, staticRenderFns }